<template>
  <template-login-page></template-login-page>
</template>

<script lang="ts">

import templateLoginPage from '@/app-template/lib/pages/LoginPage.vue';

export default {
  name: "LoginPage",
  components: { templateLoginPage },
};
</script>